import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { log } from 'log';
import { useLiveGamesSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useLiveGamesOnSocketClose = () => {
    const dispatch = useDispatch();
    const { intervalId } = useLiveGamesSelector(prop('dynamicImages'));

    return useCallback((): void => {
        dispatch(actions.updateConnectionStatus(false));
        dispatch(actions.resetTables());
        dispatch(actions.updateIsNeedToStart(false));

        log('log', '[LIVE | Portal] WebSocket connection closed');

        intervalId && clearInterval(intervalId);
        dispatch(actions.updateLiveGamesImagesIntervalId(null));
    }, [dispatch, intervalId]);
};
